import React from 'react'
import PropTypes from 'prop-types';
import Select, {components} from 'react-select';
import TextSelectStyle from './TextSelectStyle';

import buttons from './Button.scss';
import styles from './TextSelect.scss';

let customStyles = TextSelectStyle();

const TextSelect = (
	{
		valueCol,
		labelCol,
		options,
		selected,
		onChange,
		placeholder,
		onMenuOpen,
		truncateSelectedToLen,
		customStyle
	}
) => {
	TextSelect.propTypes = {
		valueCol: PropTypes.string.isRequired,
		labelCol: PropTypes.string.isRequired,
		options: PropTypes.arrayOf(PropTypes.object).isRequired,
		selected: PropTypes.string,
		onChange: PropTypes.func,
		onMenuOpen: PropTypes.func,
		placeholder: PropTypes.string,
		truncateSelectedToLen: PropTypes.number,
		customStyle: PropTypes.object
	};

	if (customStyle) {
		customStyles = customStyle;
	}

	const Option = (props) => {
		return (
			<components.Option {...props} >
				{props.data[labelCol]}
			</components.Option>
		);
	};
	if (typeof truncateSelectedToLen !== "number") {
		truncateSelectedToLen = 0;
	}
	return (
		<Select
			options={options}
			styles={customStyles}
			isSearchable={false}
			placeholder={
				<table>
					<tbody>
					<tr className={styles.anchorContainer}>
						<td>
							<a href="#" className={`${buttons.buttonLink} ${buttons.action}`}>
								{
									typeof placeholder !== 'undefined' && placeholder !== '' ? placeholder : 'Select...'
								}
							</a>
						</td>
						<td>
							<span className={styles.icon}/>
						</td>
					</tr>
					</tbody>
				</table>
			}
			components={{Option}}
			getOptionLabel={option => {
				return (
					<table>
						<tbody>
						<tr className={styles.anchorContainer}>
							<td>
								<a className={buttons.action} style={{cursor: "pointer"}}>
									{
										truncateSelectedToLen > 0 && option[labelCol].length > truncateSelectedToLen ? option[labelCol].substring(0, truncateSelectedToLen - 3) + '...' : option[labelCol]
									}
								</a>
							</td>
							<td>
								<span className={styles.icon}/>
							</td>
						</tr>
						</tbody>
					</table>
				)
			}}
			getOptionValue={option => `${option[valueCol]}`}
			onChange={onChange}
			onMenuOpen={onMenuOpen}
			value={
				(typeof selected !== 'undefined' && selected !== '') ?
					options.filter((option) => {
						if (selected === option[valueCol]) {
							return true;
						}
					})
					: false
			}/>
	)
};

export default TextSelect;


